import React from 'react'
import Layout from '../layout/Layout'
import InvoiceSvg from '../other/svg/InvoiceSvg'

const SellingInvoices = (): JSX.Element => {
  return (
    <Layout name="invoices" iconComponent={<InvoiceSvg className="w-8 h-8 text-white" />} withFiler={false}>
      <div>invoices</div>
    </Layout>
  )
}

export default SellingInvoices
